import { render, staticRenderFns } from "./playing.vue?vue&type=template&id=620c3298&scoped=true&"
import script from "./playing.vue?vue&type=script&lang=js&"
export * from "./playing.vue?vue&type=script&lang=js&"
import style0 from "./playing.vue?vue&type=style&index=0&id=620c3298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c3298",
  null
  
)

export default component.exports